import { render, staticRenderFns } from "./ReclaimCard.vue?vue&type=template&id=4ea4e482&"
import script from "./ReclaimCard.vue?vue&type=script&lang=js&"
export * from "./ReclaimCard.vue?vue&type=script&lang=js&"
import style0 from "./ReclaimCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports